import { useState } from "react";
import { CircularProgress, Button, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { reprocessExamVideo } from "../../../../../repositories/coachApi";
import { btnStyle } from "../../../../auth/styles";

const OBJECT_ID_PATTERN = /^[0-9a-fA-F]{24}$/;

const VideoReprocess = () => {
  const [patientId, setPatientId] = useState("");
  const [examId, setExamId] = useState("");
  const [loading, setLoading] = useState(false);

  const trimmedPatientId = patientId.trim();
  const trimmedExamId = examId.trim();
  const isValidPatientId = OBJECT_ID_PATTERN.test(trimmedPatientId);
  const isValidExamId = OBJECT_ID_PATTERN.test(trimmedExamId);
  const isValid = isValidPatientId && isValidExamId;

  const handleReprocess = async () => {
    if (!isValid) return;
    setLoading(true);
    try {
      const response = await reprocessExamVideo({
        patientId: trimmedPatientId,
        examId: trimmedExamId,
      });
      enqueueSnackbar(
        `Video queued for reprocessing (exam ${response?.examId ?? "unknown"})`,
        { variant: "success" }
      );
      setPatientId("");
      setExamId("");
    } catch (error: any) {
      const message =
        error?.response?.data?.error ||
        (error?.response?.status === 404
          ? "Video not found for that patient and exam"
          : "Error triggering video reprocess");
      enqueueSnackbar(message, { variant: "error" });
    }
    setLoading(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <p>
        Enter the patient id and exam id of an uploaded video to send it back
        to the ML processing pipeline.
      </p>
      <TextField
        label="Patient id"
        placeholder="6650a1b2c3d4e5f6a7b8c9d0"
        value={patientId}
        onChange={(e) => setPatientId(e.target.value)}
        error={Boolean(trimmedPatientId) && !isValidPatientId}
        helperText={
          Boolean(trimmedPatientId) && !isValidPatientId
            ? "Must be a 24-character hex id"
            : " "
        }
        fullWidth
      />
      <TextField
        label="Exam id"
        placeholder="6650f1e2d3c4b5a6978869fa"
        value={examId}
        onChange={(e) => setExamId(e.target.value)}
        error={Boolean(trimmedExamId) && !isValidExamId}
        helperText={
          Boolean(trimmedExamId) && !isValidExamId
            ? "Must be a 24-character hex id"
            : " "
        }
        fullWidth
      />
      <Button
        style={{ ...btnStyle, alignSelf: "flex-start" }}
        onClick={handleReprocess}
        disabled={!isValid || loading}
      >
        {loading ? <CircularProgress size={24} /> : "Reprocess video"}
      </Button>
    </div>
  );
};

export default VideoReprocess;
